import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
            <i className="ri-vip-crown-line"></i>
            平台优势
          </span>
          <h2 className="text-2xl md:text-3xl font-display text-foreground-950">为什么选择每日大赛黑料</h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-xl mx-auto">四大核心优势，重新定义赛事爆料体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-6 hover:border-primary-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="mt-5 text-base font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}